import { MessagingTemplateTypes } from "@enums/messaging-template-types";
import {
    EmailTemplateFieldsTemplateFileFields,
    EmailTemplateFieldsLanguageFileFields
} from "@idw-types/common/email-template-fields";

export const EMAIL_TEMPLATE_FIELDS_DCUI_EMAIL_SUBJECT_PROPERTY_NAME = "dcuiEmailSubject";
export const EMAIL_TEMPLATE_FIELDS_DCUI_FROM_EMAIL_ADDRESS_PROPERTY_NAME = "dcuiFromEmailAddress";
export const EMAIL_TEMPLATE_FIELDS_PIN_EMAIL_SUBJECT_PROPERTY_NAME = "pinEmailSubject";
export const EMAIL_TEMPLATE_FIELDS_PIN_FROM_EMAIL_ADDRESS_PROPERTY_NAME = "pinFromEmailAddress";

export const EMAIL_TEMPLATE_FIELDS_PIN_SMS_TEMPLATE_FILE_PROPERTY_NAME = "pinSMSTemplateFile";
export const EMAIL_TEMPLATE_FIELDS_PIN_EMAIL_TEMPLATE_FILE_PROPERTY_NAME = "pinEmailTemplateFile";
export const EMAIL_TEMPLATE_FIELDS_DCUI_EMAIL_TEMPLATE_FILE_PROPERTY_NAME = "dcuiEmailTemplateFile";
export const EMAIL_TEMPLATE_FIELDS_DCUI_SMS_TEMPLATE_FILE_PROPERTY_NAME = "dcuiSMSTemplateFile";

export const EMAIL_TEMPLATE_FIELDS_PIN_SMS_LANGUAGE_FILE_PROPERTY_NAME = "pinSMSLanguageFile";
export const EMAIL_TEMPLATE_FIELDS_PIN_EMAIL_LANGUAGE_FILE_PROPERTY_NAME = "pinEmailLanguageFile";
export const EMAIL_TEMPLATE_FIELDS_DCUI_EMAIL_LANGUAGE_FILE_PROPERTY_NAME = "dcuiEmailLanguageFile";
export const EMAIL_TEMPLATE_FIELDS_DCUI_SMS_LANGUAGE_FILE_PROPERTY_NAME = "dcuiSMSLanguageFile";

export const EMAIL_TEMPLATE_FIELDS_HEADER_LOGO_PROPERTY_NAME = "headerlogo";

export const MESSAGING_TEMPLATE_TYPE_TO_TEMPLATE_FIELD_NAME_MAP: Record<MessagingTemplateTypes, keyof EmailTemplateFieldsTemplateFileFields> = {
    [MessagingTemplateTypes.PIN_SMS]: EMAIL_TEMPLATE_FIELDS_PIN_SMS_TEMPLATE_FILE_PROPERTY_NAME,
    [MessagingTemplateTypes.PIN_EMAIL]: EMAIL_TEMPLATE_FIELDS_PIN_EMAIL_TEMPLATE_FILE_PROPERTY_NAME,
    [MessagingTemplateTypes.DCUI_EMAIL]: EMAIL_TEMPLATE_FIELDS_DCUI_EMAIL_TEMPLATE_FILE_PROPERTY_NAME,
    [MessagingTemplateTypes.DCUI_SMS]: EMAIL_TEMPLATE_FIELDS_DCUI_SMS_TEMPLATE_FILE_PROPERTY_NAME
};

export const MESSAGING_TEMPLATE_TYPE_TO_LANGUAGE_FIELD_NAME_MAP: Record<MessagingTemplateTypes, keyof EmailTemplateFieldsLanguageFileFields> = {
    [MessagingTemplateTypes.PIN_SMS]: EMAIL_TEMPLATE_FIELDS_PIN_SMS_LANGUAGE_FILE_PROPERTY_NAME,
    [MessagingTemplateTypes.PIN_EMAIL]: EMAIL_TEMPLATE_FIELDS_PIN_EMAIL_LANGUAGE_FILE_PROPERTY_NAME,
    [MessagingTemplateTypes.DCUI_EMAIL]: EMAIL_TEMPLATE_FIELDS_DCUI_EMAIL_LANGUAGE_FILE_PROPERTY_NAME,
    [MessagingTemplateTypes.DCUI_SMS]: EMAIL_TEMPLATE_FIELDS_DCUI_SMS_LANGUAGE_FILE_PROPERTY_NAME
};

export const messagingTemplateContentStringRegex = /\${\((.*?)\)(.*?)"}/g;
